/**
 * Textos da Área do PCP: status, duração, "há quanto tempo" e horário local.
 * Horário sempre no fuso de São Paulo (ADR-0059): o datetime vem em UTC.
 */
import { STATUS } from "./projecao";

const FUSO = "America/Sao_Paulo";

export const ROTULO_STATUS = Object.freeze({
  [STATUS.EM_ANDAMENTO]: "Em andamento",
  [STATUS.PAUSADA]: "Pausado",
  [STATUS.CONCLUIDA]: "Concluída",
  [STATUS.CANCELADA]: "Cancelada",
});

/** Tom da paleta canônica: cor só comunica estado (pausado é neutro, não erro). */
export const TOM_STATUS = Object.freeze({
  [STATUS.EM_ANDAMENTO]: "info",
  [STATUS.PAUSADA]: "neutral",
  [STATUS.CONCLUIDA]: "success",
  [STATUS.CANCELADA]: "danger",
});

export function duracao(segundos) {
  if (segundos === null || segundos === undefined) return "—";
  const minutos = Math.max(0, Math.round(segundos / 60));
  if (minutos < 60) return `${minutos}min`;
  const horas = Math.floor(minutos / 60);
  const resto = minutos % 60;
  return resto ? `${horas}h ${resto}min` : `${horas}h`;
}

export function horaLocal(iso) {
  if (!iso) return "—";
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return "—";
  return data.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", timeZone: FUSO });
}

export function dataHoraLocal(iso) {
  if (!iso) return "—";
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return "—";
  const dia = data.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", timeZone: FUSO });
  return `${dia} ${horaLocal(iso)}`;
}

/** "agora", "há 2 min", "há 3 h", "há 1 dia". */
export function haQuantoTempo(iso, agora = new Date()) {
  if (!iso) return "—";
  const segundos = Math.max(0, (agora.getTime() - new Date(iso).getTime()) / 1000);
  if (segundos < 60) return "agora";
  const minutos = Math.floor(segundos / 60);
  if (minutos < 60) return `há ${minutos} min`;
  const horas = Math.floor(minutos / 60);
  if (horas < 24) return `há ${horas} h`;
  const dias = Math.floor(horas / 24);
  return `há ${dias} ${dias === 1 ? "dia" : "dias"}`;
}

export function passoDeTotal(execucao) {
  const numero = execucao?.passo_atual?.numero;
  const total = execucao?.total_passos;
  if (!total) return "";
  if (!numero) return `${total} de ${total} passos`;
  return `Passo ${numero} de ${total}`;
}

export function percentual(concluidos, total) {
  if (!total) return 0;
  return Math.round((concluidos / total) * 100);
}
